import React from 'react';
import { Section } from './ui/Section';
export const ProblemSection = () => {
  const tableData = [{
    probaste: 'Meditación',
    porQue: 'Tu cabeza siguió pensando igual y encima te frustraste'
  }, {
    probaste: 'Pastillas para dormir',
    porQue: 'Te dormiste esa noche pero el problema volvió'
  }, {
    probaste: 'Infusiones y suplementos',
    porQue: 'Ayudan un poco pero no atacan la causa real'
  }, {
    probaste: 'Música y sonidos',
    porQue: 'Distracción temporal. Cuando para, el pensamiento vuelve'
  }, {
    probaste: 'Contar ovejas',
    porQue: 'Tu cerebro lo aburre en 30 segundos y vuelve al espiral'
  }, {
    probaste: 'Fuerza de voluntad',
    porQue: 'Intentar no pensar hace que pienses más'
  }];
  return <Section data-id="element-376">
      <div className="max-w-3xl mx-auto" data-id="element-377">
        <h2 className="text-3xl md:text-4xl font-bold mb-10 text-white" data-id="element-378">
          Por qué no podés dormir aunque estés agotado
        </h2>

        <div className="space-y-6 text-lg text-gray-300 mb-16" data-id="element-379">
          <p data-id="element-380">
            La mayoría de las personas cree que no puede dormir porque es
            ansiosa.
          </p>
          <p data-id="element-381">O porque tiene mucho estrés.</p>
          <p data-id="element-382">O porque algo está mal en ella.</p>
          <p className="text-xl font-medium text-white mt-8" data-id="element-383">
            Eso no es verdad.
          </p>
          <p data-id="element-384">El problema real es mucho más simple.</p>
          <p data-id="element-385">Y mucho más solucionable.</p>

          <div className="bg-night-900/80 border border-accent-blue/30 p-8 rounded-2xl my-8 shadow-lg" data-id="element-386">
            <p className="text-2xl text-white font-serif font-medium text-center" data-id="element-387">
              Tu cerebro no recibió la señal de que el día terminó.
            </p>
            <p className="text-center text-accent-light mt-2" data-id="element-388">Así de simple.</p>
          </div>

          <p data-id="element-389">Tu cerebro estuvo todo el día en modo activo.</p>
          <p data-id="element-390">Resolviendo. Procesando. Anticipando. Recordando.</p>
          <p data-id="element-391">Y cuando te acostás, nadie lo apagó.</p>
          <p data-id="element-392">Nadie le avisó que el día terminó.</p>
          <p data-id="element-393">Nadie lo desactivó.</p>
          <p data-id="element-394">Entonces sigue funcionando.</p>
          <p data-id="element-395">Sigue procesando.</p>
          <p data-id="element-396">Sigue buscando cosas que resolver.</p>
          <p data-id="element-397">Y vos estás ahí, con los ojos cerrados, sin poder hacer nada.</p>
        </div>

        <h3 className="text-2xl md:text-3xl font-bold mb-8 text-white" data-id="element-398">
          Por qué todo lo que probaste no funcionó
        </h3>

        <div className="overflow-x-auto pb-4" data-id="element-399">
          <table className="w-full text-left border-collapse" data-id="element-400">
            <thead data-id="element-401">
              <tr className="border-b border-night-700" data-id="element-402">
                <th className="py-4 px-6 text-accent-light font-semibold bg-night-900/50 rounded-tl-lg" data-id="element-403">
                  Lo que probaste
                </th>
                <th className="py-4 px-6 text-accent-light font-semibold bg-night-900/50 rounded-tr-lg" data-id="element-404">
                  Por qué no funcionó
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-night-700/50" data-id="element-405">
              {tableData.map((row, idx) => <tr key={idx} className="hover:bg-night-700/20 transition-colors" data-id="element-406">
                  <td className="py-4 px-6 font-medium text-white" data-id="element-407">
                    {row.probaste}
                  </td>
                  <td className="py-4 px-6 text-gray-400" data-id="element-408">{row.porQue}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-10 space-y-4 text-lg text-gray-300" data-id="element-409">
          <p data-id="element-410">Ninguna de esas cosas ataca el problema real.</p>
          <p data-id="element-411">
            El problema real es que tu cerebro no recibió la señal de que puede
            bajar.
          </p>
          <p className="text-white font-medium" data-id="element-412">
            Y mientras eso no pase, el ruido sigue.
          </p>
        </div>
      </div>
    </Section>;
};